<script>
import { VMoney } from 'v-money'
import Valor from '@components/config-task-value'
import { Percent } from '@constants/Masks'

export default {
  directives: {
    money: VMoney,
  },
  components: { Valor },
  props: {
    campos: {
      type: Object,
      required: true,
    },
    dados: {
      type: Object,
      required: true,
    },
    acao: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      maskPercent: Percent,
    }
  },
}

// Considerar campos de valor - tipo do dado e range
</script>

<template>
  <div v-if="acao">
    {{ campos }}
    <p v-if="dados.campo_parametro" style="font-weight: bold;">
      {{ acao }}
    </p>
    <div
      v-if="acao === 'low_return'"
      class="d-flex align-baseline"
      style="flex-wrap: wrap"
    >
      <p style="max-width: 230px;">Analisar clientes que possuem a</p>
      <v-select
        style="max-width: 240px"
        class="ml-2"
        dense
        hide-details
        :value="dados.campo_parametro"
        :items="campos.campo_parametro"
        label="Rentabilidade"
        width="150"
      ></v-select>
      <v-select
        style="max-width: 100px;"
        class="ml-2"
        dense
        hide-details
        :value="dados.tipo_comparacao_parametro"
        :items="campos.tipo_comparacao_parametro"
        label="Comparação"
      ></v-select>
      <p style="max-width: fit-content">que</p>
      <v-text-field
        style="max-width: 140px;"
        class="ml-2"
        dense
        hide-details
        :value="dados.valor_parametro"
        label="Porcentagem"
      >
      </v-text-field>
      <Valor :type="dados.tipo_dado_parametro" />
    </div>

    <div
      v-if="acao === 'low_share'"
      class="d-flex align-baseline"
      style="flex-wrap: wrap"
    >
      <p style="max-width: 400px">
        Analisar clientes que possuem patrimônio representando
      </p>
      <v-select
        class="ml-2"
        dense
        hide-details
        style="max-width: 110px"
        :value="dados.tipo_comparacao_parametro"
        :items="campos.tipo_comparacao_parametro"
        label="Comparação"
      ></v-select>
      <p style="max-width: fit-content">que</p>
      <v-text-field
        v-money="maskPercent"
        style="max-width: 100px"
        class="ml-2"
        dense
        hide-details
        :value="dados.valor_parametro"
        label="Valor parametro"
      >
      </v-text-field>
      <p style="max-width: fit-content">na instituição</p>
      <v-select
        class="ml-2"
        dense
        style="max-width: 230px"
        label="Instituição"
        multiple
        :value="dados.valor_parametro_v2"
        :items="campos.valor_parametro_v2"
      ></v-select>
    </div>

    <div
      v-if="acao === 'not_contracted'"
      class="d-flex align-baseline"
      style="flex-wrap: wrap;"
    >
      <p style="max-width: fit-content;">
        Analisar clientes que receberam proposta a
      </p>
      <v-select
        class="ml-2"
        dense
        style="max-width: fit-content;"
        hide-details
        :value="dados.tipo_comparacao_parametro"
        :items="campos.tipo_comparacao_parametro"
        label="Comparação"
      ></v-select>
      <v-text-field
        class="ml-2"
        dense
        style="max-width: fit-content;"
        hide-details
        :value="dados.tipo_comparacao_parametro"
        label="Valor parametro"
      >
      </v-text-field>
      <p style="max-width: fit-content;">dias</p>
    </div>

    <div
      v-if="acao === 'not_registered'"
      class="d-flex align-baseline"
      style="flex-wrap: wrap;"
    >
      <p style="max-width: fit-content;">
        Analisar clientes cadastrados que ainda não acessaram o app em
      </p>
      <v-select
        class="ml-2"
        style="max-width: fit-content;"
        dense
        hide-details
        :value="dados.tipo_comparacao_parametro"
        :items="campos.tipo_comparacao_parametro"
        label="Comparação"
      ></v-select>
      <v-text-field
        class="ml-2"
        dense
        hide-details
        style="max-width: fit-content;"
        :value="dados.tipo_comparacao_parametro"
        label="Valor parametro"
      >
      </v-text-field>
      <p style="max-width: fit-content;">dias</p>
    </div>

    <div
      v-if="acao === 'wihout_profit'"
      class="d-flex align-baseline"
      style="flex-wrap: wrap;"
    >
      <p style="max-width: fit-content;"
        >Analisar clientes que não geraram receita e que</p
      >
      <v-select
        class="ml-2"
        dense
        style="max-width: 150px;"
        hide-details
        :value="dados.campo_parametro"
        :items="campos.campo_parametro"
        label="Data"
      ></v-select>
      <p>em</p>
      <v-select
        class="ml-2"
        dense
        style="max-width: fit-content;"
        hide-details
        :value="dados.tipo_comparacao_parametro"
        :items="campos.tipo_comparacao_parametro"
        label="Comparação"
      ></v-select>
      <v-text-field
        dense
        hide-details
        style="max-width: fit-content;"
        class="ml-2"
        :value="dados.valor_parametro"
        label="Valor parametro"
      >
      </v-text-field>
      <p style="max-width: fit-content;">dias</p>
    </div>

    <div
      v-if="acao === 'without_invite'"
      class="d-flex align-baseline"
      style="flex-wrap: wrap;"
    >
      <p style="max-width: fit-content;">
        Analisar clientes que não receberam convites mas se registraram em
      </p>
      <v-select
        class="ml-2"
        hide-details
        dense
        style="max-width: fit-content;"
        :value="dados.tipo_comparacao_parametro"
        :items="campos.tipo_comparacao_parametro"
        label="Comparação"
      ></v-select>
      <v-text-field
        class="ml-2"
        hide-details
        style="max-width: fit-content;"
        dense
        :value="dados.tipo_comparacao_parametro"
        label="Valor parametro"
      >
      </v-text-field>
      <p style="max-width: fit-content;">dias</p>
    </div>

    <div
      v-if="acao === 'without_position'"
      class="d-flex align-baseline"
      style="flex-wrap: wrap;"
    >
      <p style="max-width: fit-content;">
        Analisar clientes que não possuem ativos mas se registraram em
      </p>
      <v-select
        dense
        hide-details
        class="ml-2"
        style="max-width: fit-content;"
        :value="dados.tipo_comparacao_parametro"
        :items="campos.tipo_comparacao_parametro"
        label="Comparação"
      ></v-select>
      <v-text-field
        dense
        hide-details
        class="ml-2"
        style="max-width: fit-content;"
        :value="dados.tipo_comparacao_parametro"
        label="Valor parametro"
      >
      </v-text-field>
      <p style="max-width: fit-content;">dias</p>
    </div>

    <div v-if="dados.frequencia">
      <p style="max-width: fit-content;">
        Executada a cada {{ dados.frequencia }} {{ dados.escala_frequencia }}
      </p>
    </div>
  </div>
</template>


